import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cx from "clsx";
import SSRIcon from "@ingka/ssr-icon";
import ChevronDownIcon from "@ingka/ssr-icon/paths/chevron-down-small";
import ChevronUpIcon from "@ingka/ssr-icon/paths/chevron-up-small";
export const BaseSelectSelector = ({ onToggleOpen, open, children, disabled = false, hasError = false, visibleFocus = false, ...props }) => (_jsx("div", { className: cx("pdpp-react-baseSelectInput", {
        "pdpp-react-baseSelectInputOpenedFocus": open,
        "pdpp-react-baseSelectInputOpenedVisibleFocus": visibleFocus,
        "pdpp-react-baseSelectInputOpenedDisabled": disabled,
        "pdpp-react-baseSelectInputWithoutError": !hasError,
        "pdpp-react-baseSelectInputOpenedHasError": hasError,
    }), role: "button", tabIndex: 0, onClick: onToggleOpen, ...props, children: _jsxs("div", { className: "pdpp-react-baseSelectInsideContainer", children: [children, _jsx(SSRIcon, { paths: open ? ChevronUpIcon : ChevronDownIcon })] }) }));
//# sourceMappingURL=BaseSelectSelector.js.map